export default __webpack_public_path__ + "static/media/video-search-on-icon.af973d21.png";